<div class="text-container">{{textToDisplay}}</div>
<span *ngIf="showMore == true" class="expand-btn" (click)="more()">{{getString('more')}}</span>
<span *ngIf="showLess == true" class="expand-btn" (click)="less()">{{getString('less')}}</span>